import React, { Component } from 'react';
import firebase from 'firebase';
import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';
import Modal from 'react-modal';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import './modal.css';
import secondaryApp from '../BD/secondaryApp';


const database=firebase.database();

const customStyles = {
  content : {
    top                   : '88%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};
const customStylesSocios = {
  content : {
    top                   : '70%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	,
	boxShadow             : '1px 3px 1px #9E9E9E'
  }
};


class Modal_Empleados extends Component {
	
	constructor(){
		
		super();
		this.state={
		
			
			socios:[],
			vehiculos:[],
			vehiculos1:[],
			isActiveSocios:false,
			isActiveVehiculos:false,
			isActive:false,
			nombre:'',
			edad:'',
			dui:'',
			direccion:'',
			licencia:'',
			placa:'',
			socio:'',
			socioKey:'',
			telefono:'',
			latitud:'',
			longitud:'',
			foto:'',
			urlFoto:'',
			uploadValue:0,
			files:null,
			marca:'',  //del vehiculo
			modelo:'',  //del vehiculo
			uid:'',
			uidVehiculo:''
			
			
		};
		
		this.handleUpload=this.handleUpload.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleKeyPressDui=this.handleKeyPressDui.bind(this);
		this.handleKeyPressLicencia=this.handleKeyPressLicencia.bind(this);
		this.llenar=this.llenar.bind(this);
		this.handleClickVehiculos=this.handleClickVehiculos.bind(this);
		this.toggleModalVehiculos=this.toggleModalVehiculos.bind(this);
		this.empleadosRef=database.ref().child('Empleados');
		this.sociosRef=database.ref().child('Socios');
		this.vehiculosRef=database.ref().child('Vehiculos');
		
		
	}
	
	componentWillMount(){
		
		Modal.setAppElement('body');
	}
	
	componentWillUnmount = () => {
		this.vehiculosRef.off();
	}
	
	componentDidMount(){
		
		this.sociosRef.once('value', this.gotDataSocios, this.errDataSocios);
		this.vehiculosRef.off();
		this.vehiculosRef.on('value', this.gotDataVehiculos,this.errDataVehiculos);
	}	
	
	//get the data from the firebase and push them out
	gotDataSocios = (data) => {
		  let newsocios = []
		  const sociosdata = data.val();
		  const keys = Object.keys(sociosdata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			
			if(sociosdata[k].Estado!=='Inactivo'){
			
				newsocios.push({
				  key:k,
				  nombre:sociosdata[k].Nombre,
				  apellido:sociosdata[k].Apellido,
				  estado:sociosdata[k].Estado

				});			
				
			}

			
      }
      this.setState({socios: newsocios});
		}
		errDataSocios = (err) => {	
	  console.log(err);
	}
	
	//get the data from the firebase and push them out
	gotDataVehiculos = (data) => {
		  let newVehiculo = []
		  const vehiculodata = data.val();
		  const keys = Object.keys(vehiculodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			
			
			newVehiculo.push({
			  key:k,
			  anio:vehiculodata[k].anio,
			  capacidad:vehiculodata[k].capacidad,
			  codigo_socio:vehiculodata[k].codigo_socio,
			  disponibilidad:vehiculodata[k].disponibilidad,
			  estado:vehiculodata[k].estado,
			  foto:vehiculodata[k].foto,
			  marca:vehiculodata[k].marca,
			  modelo:vehiculodata[k].modelo,
			  placa:vehiculodata[k].placa,
			  tipo_vehiculo:vehiculodata[k].tipo_vehiculo
		
			});
		  }
		  this.setState({vehiculos: newVehiculo,vehiculos1:newVehiculo});
		}
		errDataVehiculos = (err) => {
	  console.log(err);
	}
	
	llenar(){
		
		
		this.state.vehiculos=this.state.vehiculos1
	}
	
	
	toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0,
			placa:'',
			socio:'',
			socioKey:'',
			modelo:'',
			marca:''
			
		})
		
	}
	
	toggleModalSocios=()=>{
		
		
		this.setState({
			isActiveSocios:!this.state.isActiveSocios,
			marca:'',
			modelo:''
			
		})
		
	}
	
	toggleModalVehiculos=()=>{
		
			this.setState({
				isActiveVehiculos:!this.state.isActiveVehiculos
			
			})
		
		
	
	}

	
	//handle para envio del formulario
	handleSubmit(event){
			
		
		let vehiculo=this.state.vehiculos1.find(vehiculo=> vehiculo.key===this.state.placa);
		
		
		let tipo_vehiculo=vehiculo.tipo_vehiculo;
		
		
		
		if(this.passwordConductor.value === this.confirmPasswordConductor.value){
		
			
		//Creando cuenta para el conductor
		secondaryApp.auth().createUserWithEmailAndPassword(this.correoConductor.value,this.passwordConductor.value)
		.then(user => {
			
				this.state.uid=user.uid
				secondaryApp.auth().signOut();	
	
				let archivo=this.state.files;
		const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);
		
		const task= storageRef.put(archivo);
		
		task.on('state_changed', snapshot =>{
		
		
		this.setState({
		  uploadValue :50,
		})

		}, error =>{ console.log(error.message);
		},
		()=>{
			
				let hijoUid=this.empleadosRef.child(this.state.uid);
		
		
					hijoUid.update({
						
							uid:this.state.uid,
							correo:this.correoConductor.value,
							direccion:this.direccionConductor.value,
							dui:this.duiConductor.value,
							edad:this.edadConductor.value,
							estado:'activo',
							foto:task.snapshot.downloadURL,
							latitud:0,
							longitud:0,
							nombre:this.nombreConductor.value,
							vehiculo:this.state.placa,
							licencia:this.licenciaEmpleado.value,
							socio:firebase.auth().currentUser.uid,
							telefono:this.telefonoConductor.value,
							viaje:'desactivo',
							tipo_vehiculo:tipo_vehiculo
						
						
					});
					
					database.ref().child('Vehiculos').child(this.state.placa).update({
						
						estado:'Asignado'
					})
						
					this.setState({
						uploadValue:100,
						urlFoto:task.snapshot.downloadURL
					});
					
					this.toggleModal();
					
					Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
				
		});
				
		})
		.catch(error =>{
			
				let msj='Error al ingresar usuario';
			
				if(error.code==='auth/email-already-in-use'){	
					msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
				}
				else if(error.code==='auth/invalid-email'){					
					msj='Dirección de correo electronico no valida.';					
				}
				
				else if(error.code==='auth/weak-password'){
					
					msj='La contraseña ingresada no es demasiado fuerte.';
						
				}

				Alert.error(msj, {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
				});
			
				
		});
		
		
		
		}
		else{
			
				Alert.error('Las contraseñas ingresadas no coinciden', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
				});
			
		}
		
		
		event.preventDefault();
	
		
	}
	
	//handle para generar vista previa de los vehiculos
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);
			
			
		}

		
	}
	
	
	//handle para seleccion de socios
	handleClick = (rowKey) => {
		
		this.llenar();
		
	 
		  let vehiculotemp=[];
		
		  for (let i = 0; i <this.state.vehiculos.length; i++) {
			
			
			
			
			if((firebase.auth().currentUser.uid===this.state.vehiculos[i].codigo_socio) && (this.state.vehiculos[i].estado!=='Asignado') ){
				
				
				vehiculotemp.push({
					
					
					  key:this.state.vehiculos[i].key,
					  anio:this.state.vehiculos[i].anio,
					  capacidad:this.state.vehiculos[i].capacidad,
					  codigo_socio:this.state.vehiculos[i].codigo_socio,
					  disponibilidad:this.state.vehiculos[i].disponibilidad,
					  estado:this.state.vehiculos[i].estado,
					  foto:this.state.vehiculos[i].foto,
					  marca:this.state.vehiculos[i].marca,
					  modelo:this.state.vehiculos[i].modelo,
					  placa:this.state.vehiculos[i].placa
							
				});
				
				
			}
			
			
		  }
		  
		  this.setState({
			  
			 vehiculos:vehiculotemp 
		  });
		
			this.toggleModalVehiculos();
	}

	//handle para modal seleccion de vehiculos
	handleClickVehiculos=(rowKey)=>{
		
		this.setState({
			
			placa:rowKey.key,
			marca:rowKey.marca+' ',
			modelo:rowKey.modelo
		});
		
		this.toggleModalVehiculos();
		
	}
	

	//Formatos de botones
	btnSoiciosFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Seleccionar</button>;
	}
	
	btnVehiculosFormatter(cell,row){
		
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickVehiculos(row)}} >Seleccionar</button>;
	}
	
	handleKeyPressLetras(e){
		
		//e.which
		
		let tecla=e.which;
		
		let patron =/^[a-zA-Z]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!==32){
			
			e.preventDefault();
			
		}
	
	}
	handleKeyPressNumeros(e){
		
		//e.which

		let tecla=e.which;
		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			
			e.preventDefault();
			
		}
	
	}
	handleKeyPressDui(e){
		
		let dui=this.duiConductor.value;
		let tecla=e.which;
		
		if(dui.length===8)
		{
			if(!(tecla===45)){
				
				e.preventDefault();
			}
			
		}else{
			
			
			let patron =/^[0-9]+$/;
			
			let tecla_final = String.fromCharCode(tecla);
			
			let rs=patron.test(tecla_final);
		
			if(!rs){
				
				e.preventDefault();
			}
		}
			
	}

	handleKeyPressLicencia(e) {
		let licencia = this.licenciaEmpleado.value;
		let tecla = e.which;
		let tecla_final = String.fromCharCode(tecla);
		let longitudSinGuiones = licencia.replace(/-/g, '').length;

		let esDigito = /^[0-9]+$/.test(tecla_final);

		let permitirGuion = (tecla === 45) && (
			(longitudSinGuiones === 4 || longitudSinGuiones === 10 || longitudSinGuiones === 13) && licencia.match(/^\d{4}-?\d{0,6}-?\d{0,3}-?\d{0,1}$/) != null || // Para el patrón 1
			(longitudSinGuiones === 8 && licencia.match(/^\d{8}-?\d{0,1}$/) != null) // Para el patrón 2
		);

		if ((!permitirGuion && !esDigito) || longitudSinGuiones >= 17) {
			e.preventDefault();
		}
	}

	validateLicencia() {
		let licencia = this.licenciaEmpleado.value;

		let patron1Completo = /^\d{4}-\d{6}-\d{3}-\d{1}$/.test(licencia);
		let patron2Completo = /^\d{8}-\d{1}$/.test(licencia);

		if (!patron1Completo && !patron2Completo) {
			this.licenciaEmpleado.setCustomValidity("La licencia ingresada no cumple con los patrones requeridos.");
		} else {
			this.licenciaEmpleado.setCustomValidity("");
		}
		this.licenciaEmpleado.reportValidity();
	}


	render() {
		return (
			<div className="modal_empleados">
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
				
			
						<h2>Conductores</h2>
						<hr/>
				
				
						<form method="POST" action="" onSubmit={this.handleSubmit}>
							
							<div className="form-group">
								<label htmlFor="nombre">Nombre</label>
								<input type="text" name="nombre" className="form-control"
								placeholder="Nombre" required autoComplete="off"
								ref={input => {this.nombreConductor=input;}} onKeyPress={this.handleKeyPressLetras}
								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="dui">Dui</label>
								
								<input className="form-control" 
								placeholder="Dui" required autoComplete="off"
								minLength="10" maxLength="10"
								ref={input => {this.duiConductor=input;}}
								onKeyPress={this.handleKeyPressDui}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="direccion">Direccion</label>
								<input type="text" name="direccion" className="form-control"
								placeholder="Dirección" required autoComplete="off"
								ref={input => {this.direccionConductor=input;}} 
								/>
							</div>
							
							<div className="form-group">
								<label htmlFor="edad">Edad</label>
								<input type="text" name="edad" className="form-control"
								placeholder="Edad" required autoComplete="off"
								ref={input => {this.edadConductor=input;}} onKeyPress={this.handleKeyPressNumeros}
								minLength="2" maxLength="2"
							/>
						</div>

						<div className="form-group">
							<label htmlFor="licencia">Licencia</label>
							<input type="text" className="form-control" name="licencia"
								ref={input => { this.licenciaEmpleado = input; }}
								placeholder="Licencia" onKeyPress={this.handleKeyPressLicencia}
								onChange={this.validateLicencia.bind(this)}
								autoComplete="off" required maxLength="17"
								defaultValue={this.state.licencia}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="telefono">Telefono</label>
							<input type="text" name="telefono" className="form-control"
								placeholder="Telefono" required autoComplete="off"
								ref={input => {this.telefonoConductor=input;}} onKeyPress={this.handleKeyPressNumeros}
								minLength="8" maxLength="8"
								/>
							</div>
							<div className="form-group">
								<label htmlFor="correo">Correo</label>
								<input type="email" name="correo" className="form-control"
								placeholder="Correo" required autoComplete="off"
								ref={input => {this.correoConductor=input;}}  
								/>
							</div>
							<div className="form-group">
								<label htmlFor="password">Contraseña</label>
								<input  type="password" name="password" className="form-control"
								placeholder="Contraseña" required autoComplete="off"
								ref={input => {this.passwordConductor=input;}}
								minLength="6" maxLength="10"
								/>							
							</div>
							<div className="form-group">
								<label htmlFor="confirm-password">Confimar Contraseña</label>
								<input type="password" name="confirm-password" className="form-control"
								placeholder="Confirmar Contraseña" required autoComplete="off"
								ref={input => {this.confirmPasswordConductor=input;}}
								minLength="6" maxLength="10"
								/>
							</div>
						
							
							<div className="form-group">
								<label htmlFor="vehiculo">Vehiculo</label>
								<input type="text" name="vehiculo" className="form-control"
								placeholder="Selecciona un vehiculo" required onClick={this.toggleModalVehiculos}
								value={this.state.marca+this.state.modelo} readOnly="readonly"
								ref={input => {this.placaConductor=input;}}  onClick={this.handleClick}
								
								/>
								<input type="hidden" name="placa" value={this.state.placa}  />
							</div>
							<div className="form-group">
								<label htmlFor="foto">Foto del conductor</label>
								<br/>
								<progress value={this.state.uploadValue} max="100"></progress>
								<input type="file" className="form-control"  onChange={this.handleUpload} required/>
							</div>
							<div className="image">
								<img src={this.state.foto} className="foto"  width="250px;" alt="foto del conductor"/>
							</div>
							<br/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
						
					</form>	
					
					
					</Modal>
						
					<Modal isOpen={this.state.isActiveSocios} onRequestClose={this.toggleModalSocios}  style={customStyles}>
						<h4>Selecciona un socio</h4>
						<hr/>
					
						<BootstrapTable data={ this.state.socios}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnSoiciosFormatter.bind(this) }>Editar</TableHeaderColumn>
					</BootstrapTable>
					
					</Modal>
					
					<Modal isOpen={this.state.isActiveVehiculos} onRequestClose={this.toggleModalVehiculos}  style={customStyles}>
						<h4>Selecciona un vehiculo</h4>
						<hr/>
					
							
								
							
								

							<BootstrapTable data={ this.state.vehiculos}
								 ref='table'
								 pagination={ true }
								 search={ true }
								 hover
								 >
								<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn dataField='marca' dataSort={true}>Marca</TableHeaderColumn>
								<TableHeaderColumn dataField='modelo' dataSort={true}>Modelo</TableHeaderColumn>
								<TableHeaderColumn dataField='placa'>Placa</TableHeaderColumn>
	
								 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnVehiculosFormatter.bind(this) }>Editar</TableHeaderColumn>
							</BootstrapTable>								
							
						
					
								
								
							
					
					</Modal>
		
	
		</div>
      
    );
  }
}

export default Modal_Empleados;



// WEBPACK FOOTER //
// ./src/Components/Perfil_Socios/modal_empleados.js